export default {
  isJailBroken: () => false,
}
